module.exports = __webpack_public_path__ + "static/img/logo-01.ca2a4b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apphome/logo-01.png
// module id = I6FK
// module chunks = 1